<div
  class="tab-pane fade flex-even active show h-100"
  id="sales"
  role="tabpanel"
  aria-labelledby="sales-tab"
>
  <div class="d-flex flex-column h-100">
    @if (this.salesObjectivesRules$ | async; as salesObjectivesRuleModels) {
      @if ((this.viewIsAllowed$ | async) === true) {
        <div class="row mt-2">
          <div class="col-12 col-md">
            <button
              type="button"
              [class]="ButtonType.Primary | buttontypepipe"
              class="btn-sm btn"
              translate
              (click)="onClickOpenEditModal()"
            >
              USER_LBL_SALES_OBJECTIVES_RULES_ADD
            </button>
          </div>
        </div>
      }

      <div class="row mt-2">
        <div class="col-12 col-md">
          <app-generic-grid
            style="height: 300px"
            [data]="salesObjectivesRuleModels"
            [tabViewName]="this.tabViewName"
            (onActionClickedSetRowData)="onSetRowData($event)"
          />
        </div>
      </div>
    }
  </div>
</div>
